import {isDevEnv} from './env';
import {generateEvents, generateOldEvents, getRandomIssueNumber} from './mocks/mock-data';

export const getData = (route, transporter = fetch) => {
    if (!isDevEnv || !process.env.REACT_APP_MOCK_DATA) {
        return transporter(route).then(result => result.json());
    }

    const checksComplete = Math.random() > 0.1;

    return Promise.resolve({
        canDismissEvents: checksComplete && Math.random() > 0.5,
        checksComplete,
        events: [
            ...generateEvents(getRandomIssueNumber()),
            ...generateOldEvents(getRandomIssueNumber())
        ]
    });
};

export const flatObjectToEncodedFormData = obj => Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');



// WEBPACK FOOTER //
// ./src/api.js